export function parseHex(value) {
    if (typeof value !== "string")
        return null;
    const v = value.trim().replace(/^#/, "");
    const full = v.length === 3
        ? v
            .split("")
            .map((c) => c + c)
            .join("")
        : v;
    if (!/^[0-9a-f]{6}$/i.test(full))
        return null;
    return {
        r: parseInt(full.slice(0, 2), 16),
        g: parseInt(full.slice(2, 4), 16),
        b: parseInt(full.slice(4, 6), 16),
    };
}
export function isHexColour(value) {
    return (typeof value === "string" && /^#([0-9a-f]{3}|[0-9a-f]{6})$/i.test(value));
}
export function toHex({ r, g, b }) {
    const h = (n) => Math.max(0, Math.min(255, Math.round(n)))
        .toString(16)
        .padStart(2, "0");
    return `#${h(r)}${h(g)}${h(b)}`;
}
export function relativeLuminance(hex) {
    const c = parseHex(hex);
    if (!c)
        return null;
    const ch = [c.r, c.g, c.b].map((v) => {
        const s = v / 255;
        return s <= 0.03928 ? s / 12.92 : ((s + 0.055) / 1.055) ** 2.4;
    });
    return 0.2126 * ch[0] + 0.7152 * ch[1] + 0.0722 * ch[2];
}
export function contrastRatio(a, b) {
    const la = relativeLuminance(a);
    const lb = relativeLuminance(b);
    if (la === null || lb === null)
        return null;
    const [hi, lo] = la > lb ? [la, lb] : [lb, la];
    return (hi + 0.05) / (lo + 0.05);
}
export function mixHex(a, b, t) {
    const x = parseHex(a);
    const y = parseHex(b);
    if (!x || !y)
        return null;
    return toHex({
        r: x.r + (y.r - x.r) * t,
        g: x.g + (y.g - x.g) * t,
        b: x.b + (y.b - x.b) * t,
    });
}
export function rgbTriplet(hex) {
    const c = parseHex(hex);
    return c ? `${c.r} ${c.g} ${c.b}` : null;
}
export function formatRatio(ratio) {
    return `${(Math.floor(ratio * 10) / 10).toFixed(1)}:1`;
}
